import './CountDownBar.css'
import React, {useEffect} from "react";

type CountDownBarProps = {
    gameState: number,
    handleGameState: (status: number) => void,
    countDownSeconds: number,
    setCountDownSeconds: React.Dispatch<React.SetStateAction<number>>,
    inputWords: string[],
}

// 游戏中倒计时
const CountDownBar: React.FC<CountDownBarProps> = ({
                                                       gameState,
                                                       handleGameState,
                                                       countDownSeconds,
                                                       setCountDownSeconds,
                                                       inputWords
                                                   }) => {
    // 先设定一个总计时间
    const totalSeconds = 1800;

    // 每次添加单词都变化一次
    useEffect(() => {
        if (gameState === 1) {
            // 在游戏中的时候，每变化一次单词列表，就变化一次进度条的背景色为红色，达到闪烁一次红色的效果
            const countdownBar = document.getElementById('countdown-daily-bar');
            if (countdownBar) {
                countdownBar.style.backgroundColor = "red";
                // 100毫秒后去掉
                setTimeout(() => {
                    countdownBar.style.backgroundColor = "#256EED";
                }, 200);
            }
        }
    }, [inputWords]);

    // 开始倒计时
    useEffect(() => {

        // 计算倒计时的间隔时间（毫秒）
        const interval2 = setInterval(() => {
            if (gameState === 1) {
                setCountDownSeconds((prevTime: number) => {
                    if (prevTime <= 0) {
                        handleGameState(2);
                        clearInterval(interval2);
                        return prevTime;
                    } else {
                        return prevTime - 1;
                    }
                });
            }
        }, 1000);
        if (countDownSeconds <= 0) {
            // 修改游戏状态为结束【输了】
            handleGameState(2);
        }


        if (gameState === 2 || gameState === 3) {
            clearInterval(interval2);
        }
        // 清除定时器，避免内存泄漏
        return () => clearInterval(interval2);
    }, [gameState]);


    // 格式化seconds为mm:ss
    const formatTimeForCount = () => {
        const minutes = Math.floor(countDownSeconds / 60);
        const remainingSeconds = countDownSeconds % 60;
        return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
    };

    // 计算进度条比例，根据countDownSeconds和totalSeconds
    const progressRatio = (countDownSeconds / totalSeconds) * 100;

    return (
        <div className={`countdown-bar-container`}>
            <div id="countdown-daily-bar" className="countdown-bar" style={{width: `${progressRatio}% `}}/>
            <div className="countdown-bar-text-container"
                 style={{
                     width: countDownSeconds > 600 ? `${progressRatio}%` : '100%',
                     justifyContent: countDownSeconds > 600 ? 'end' : 'center'
                 }}>
                <div
                    className={`countdown-bar-text my-roboto-medium ${countDownSeconds > 600 ? 'countdown-bar-white-color' : 'countdown-bar-red-color'}`}>{formatTimeForCount()}</div>
            </div>
        </div>
    );
};
export default CountDownBar;